import '/app/brewery-packages/content/content-editor-plugin-ordered-list/src/OrderedList.css-raw';
export default {
  "orderedList": "contacts-cbf4f629-orderedList-Gei3fa"
};